import React, { useCallback, useEffect } from "react"
import { IconX } from "@tabler/icons-react"

type Props = {
  open: boolean
  onClose: () => void
  title: string
  titleId?: string
  children: React.ReactNode
}

const LandingFormModal: React.FC<Props> = ({ open, onClose, title, titleId, children }) => {
  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  useEffect(() => {
    if (!open) return

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") handleClose()
    }

    document.addEventListener("keydown", handleEscape)
    document.body.style.overflow = "hidden"

    return () => {
      document.removeEventListener("keydown", handleEscape)
      document.body.style.overflow = ""
    }
  }, [open, handleClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={handleClose}
    >
      <div
        className="relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white shadow-[0px_25px_50px_-12px_rgba(0,0,0,0.25)]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close"
          className="absolute right-4 top-4 z-10 flex size-9 items-center justify-center rounded-full text-[#4a454f] transition-colors hover:bg-[#f5f5f5]"
        >
          <IconX size={20} stroke={1.5} />
        </button>

        <div className="flex flex-col gap-6 px-6 py-8 md:px-8">
          <h2
            id={titleId}
            className="pr-8 font-outfit text-2xl font-semibold tracking-tight text-dc-primary-900"
          >
            {title}
          </h2>
          {children}
        </div>
      </div>
    </div>
  )
}

export default LandingFormModal
